import UserName from "../../../SharedComponents/UserName";

const HomePageGreeting = ({ firstname = "", lastname = "", mmid = null }) => {
  return (
    <div className="container">
      <h1 id="applicantGreeting">
        Hello,&nbsp;
        <UserName firstname={firstname} lastname={lastname} />
      </h1>
    </div>
  );
};

export default HomePageGreeting;
